import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {CommonModule} from "@angular/common";
import {ChildReportComponent} from "./ops-reports/child-report/child-report.component";
import {WeeklyReportsComponent} from "./ops-reports/weekly-reports/weekly-reports.component";
import {AdmissionRecordsComponent} from "./ops-reports/admission-records/admission-records.component";
import {BirthdayReportsComponent} from "./ops-reports/birthday-reports/birthday-reports.component";
import {ImpactReportsComponent} from "./education-reports/impact-reports/impact-reports.component";
import {
  EducationImpactReportTableComponent
} from "./education-reports/education-impact-report-table/education-impact-report-table.component";
import {
  ImpactReportCounselingComponent
} from "./counselling-reports/impact-report-counseling/impact-report-counseling.component";
import {
  CounselingImpactReportTableComponent
} from "./counselling-reports/counseling-impact-report-table/counseling-impact-report-table.component";
import {ChallengesComponent} from "./counselling-reports/challenges/challenges.component";
import {InterventionComponent} from "./counselling-reports/intervention/intervention.component";
import {CountTableComponent} from "./ops-reports/count-table/count-table.component";
import {InterventionTableComponent} from "./counselling-reports/intervention-table/intervention-table.component";
import {ProgressComponent} from "./counselling-reports/progress/progress.component";
import {FollowUpComponent} from "./counselling-reports/follow-up/follow-up.component";
import {ReportCardTableComponent} from "./education-reports/report-card-table/report-card-table.component";
import {ReportCard} from "./education-reports/report-card/report-card.component";
import {AttendanceReportComponent} from "./education-reports/attendance-report/attendance-report.component";
import {LocationStateReportComponent} from "./ops-reports/location-state-report/location-state-report.component";
import {AllergyTypeReportComponent} from "./ops-reports/allergy-type-report/allergy-type-report.component";
import {BloodGroupReportComponent} from "./ops-reports/blood-group-report/blood-group-report.component";
import {GenderCountReportComponent} from "./ops-reports/gender-count-report/gender-count-report.component";
import {UnitReportComponent} from "./ops-reports/unit-report/unit-report.component";
import {HospitalReportComponent} from "./ops-reports/hospital-report/hospital-report.component";
import {AgeGroupReportComponent} from "./ops-reports/age-group-report/age-group-report.component";
import {HospitalCountReportComponent} from "./ops-reports/hospital-count-report/hospital-count-report.component";
import {TreatmentDurationComponent} from "./ops-reports/treatment-duration/treatment-duration.component";
import {ChildCaseStudyComponent} from "./ops-reports/child-case-study/child-case-study.component";
import {CounsellingLogTableComponent} from "./counselling-log-table/counselling-log-table.component";
import {EducationLogTableComponent} from "./education-log-table/education-log-table.component";
import {
  ViewImpactReportCounselingComponent
} from "./counselling-reports/view-counseling-impact-report/view-impact-report-counseling.component";
import {
  ViewImpactReportsComponent
} from "./education-reports/view-education-impact-report/view-impact-reports.component";
import {
  CounsellingSessionCountReportComponent
} from "./counselling-session-count-report/counselling-session-count-report.component";
import {ComparisonInterventionComponent} from "./comparison-intervention/comparison-intervention.component";
import {
  EducationCountReportComponent
} from "./education-reports/education-count-report/education-count-report.component";
import {CentreRankingComponent} from "./centre-ranking/centre-ranking.component";
import {OccupancyComponent} from "./occupancy/occupancy.component";
import {CustomUnitReportComponent} from "./custom-unit-report/custom-unit-report.component";
import {
  FollowupSessionsOverviewComponent
} from "./counselling-reports/followup-sessions-overview/followup-sessions-overview.component";
import {
  CounsellingOverview2Component
} from "./counselling-reports/counselling-overview2/counselling-overview2.component";
import {
  EducationFollowUpOverviewComponent
} from "./education-follow-up-overview/education-follow-up-overview.component";
import {
  EducationMixSessionReportComponent
} from "./education-reports/education-mix-session-report/education-mix-session-report.component";
import {DischargeReasonReportComponent} from "./ops-reports/discharge-reason-report/discharge-reason-report.component";
import {ChildReportFullDataComponent} from "./ops-reports/child-report-full-data/child-report-full-data.component";
import {
  AddChildCaseStudyComponent
} from "./ops-reports/child-case-study/add-child-case-study/add-child-case-study.component";
import {
  ChildCaseStudyViewComponent
} from "./ops-reports/child-case-study/child-case-study-view/child-case-study-view.component";
import {HospitalWiseOccupancyComponent} from "./ops-reports/hospital-wise-occupancy/hospital-wise-occupancy.component";
import {OccupancyReportsComponent} from "./ops-reports/occupancy-reports/occupancy-reports.component";
import {DailyChildOccupancyComponent} from "./ops-reports/daily-child-occupancy/daily-child-occupancy.component";
import {HighlightComponent} from "./ops-reports/highlight/highlight.component";
import {AddHeighlightComponent} from "./ops-reports/highlight/add-heighlight/add-heighlight.component";
import {ViewHighlightComponent} from "./ops-reports/highlight/view-highlight/view-highlight.component";
import {EfficiencyReportComponent} from "./ops-reports/efficiency-report/efficiency-report.component";
import {
  CenterHighlightListComponent
} from "./ops-reports/highlight/center-heighlight/center-highlight-list/center-highlight-list.component";
import {
  AddCenterHighlightComponent
} from "./ops-reports/highlight/center-heighlight/add-center-highlight/add-center-highlight.component";
import {
  CenterHighlightViewComponent
} from "./ops-reports/highlight/center-heighlight/center-highlight-view/center-highlight-view.component";
import {AdcTempReportComponent} from "./ops-reports/adc-temp-report/adc-temp-report.component";
import {GuardianReportComponent} from "./ops-reports/guardian-report/guardian-report.component";
import {
  CounsellingSessionsCountComponent
} from "./counselling-reports/counselling-sessions-count/counselling-sessions-count.component";
import {
  EducationHightlightReportComponent
} from "./education-reports/education-hightlight-report/education-hightlight-report.component";
import {
  EducationPresentationComponent
} from "./education-reports/education-presentation/education-presentation.component";
import {EducationMisReposrtComponent} from "./education-reports/education-mis-reposrt/education-mis-reposrt.component";
import {
  EducationPresentationListComponent
} from "./education-reports/education-presentation-list/education-presentation-list.component";
import {
  EducationSessionCountsNewComponent
} from "./education-reports/education-session-counts-new/education-session-counts-new.component";
import {AddmissionLogHistoryComponent} from "./ops-reports/addmission-log-history/addmission-log-history.component";
import {
  CounsellingPresentationListComponent
} from "./counselling-reports/Counselling Presentation/counselling-presentation-list/counselling-presentation-list.component";
import { CounsellingPresentationComponent } from "./counselling-reports/Counselling Presentation/counselling-presentation/counselling-presentation.component";
import { RevisedChildReportComponent } from "./ops-reports/revised-child-report/revised-child-report.component";
import { AnnualImpactReportComponent } from "./annual-impact-report/annual-impact-report.component";
import { AnnualImpactReportTableComponent } from "./annual-impact-report/annual-impact-report-table/annual-impact-report-table.component";
import { AverageStayReportComponent } from "./ops-reports/average-stay-report/average-stay-report.component";
import { NarrativeImpactReportComponent } from "./narrative-impact-report/narrative-impact-report.component";
import { NarrativeImpactReportTableComponent } from "./narrative-impact-report/narrative-impact-report-table/narrative-impact-report-table.component";
import { OmShantiReportComponent } from "./ops-reports/om-shanti-report/om-shanti-report.component";

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'child-report'
  },
  {
    path: 'child-report',
    component: ChildReportComponent
  },
  {
    path: 'child-report-full-data',
    component: ChildReportFullDataComponent
  },

  {
    path: 'occupancy',
    component: OccupancyComponent
  },
  {
    path: 'hospital-wise-occupancy',
    component: HospitalWiseOccupancyComponent
  },{
      path: 'app-education-session-counts-new',
    component: EducationSessionCountsNewComponent
  },
  {
    path: 'highlight',
    component: HighlightComponent
  },
  {
    path: 'add-highlight',
    component: AddHeighlightComponent
  },
  {
    path: 'add-highlight/:id',
    component: AddHeighlightComponent
  },

  {
    path: 'view-highlight/:id',
    component: ViewHighlightComponent
  },
  {path:'highlight-list',
  component:CenterHighlightListComponent},
  {
    path:'add-center-highlight/:id',
    component:AddCenterHighlightComponent
  },
  {
    path:'add-center-highlight',
    component:AddCenterHighlightComponent
  },
  {
    path: 'center-highlight-view/:id',
    component: CenterHighlightViewComponent
  },
  {
    path: 'comparison',
    component: ComparisonInterventionComponent
  },
  {
    path: 'ranking',
    component: CentreRankingComponent
  },
  {
    path: 'counselling-log',
    component: CounsellingLogTableComponent
  },
  {
    path: 'guardian-report',
    component: GuardianReportComponent
  },
  {
    path: 'education-log',
    component: EducationLogTableComponent
  },
  {
    path: 'education-overview',
    component: EducationFollowUpOverviewComponent
  },
  {
    path: 'daily-child-occupancy',
    component: DailyChildOccupancyComponent
  },
  {
    path: 'weekly-report',
    component: WeeklyReportsComponent
  },
  {
    path: 'occupancy-report',
    component: OccupancyReportsComponent
  },
  {
    path: 'efficiency-report',
    component: EfficiencyReportComponent
  },
  {
    path: 'admission-report',
    component: AdmissionRecordsComponent
  },
  {
    path: 'admission-count-report',
    component: AdcTempReportComponent
  },
  {
    path: 'birthday-report',
    component: BirthdayReportsComponent
  }, {
    path: 'impact-report',
    component: ImpactReportsComponent
  },
  {
    path: 'impact-report/:id',
    component: ImpactReportsComponent
  },
  {
    path: 'view-impact-report/:id',
    component: ViewImpactReportsComponent
  },
  {
    path: 'impact-report-table',
    component: EducationImpactReportTableComponent
  },
  {
    path: 'impact-report-counseling',
    component: ImpactReportCounselingComponent
  },
  {
    path: 'mix-count-report',
    component: EducationMixSessionReportComponent
  },
  {path:'education-mis-report',
    component:EducationMisReposrtComponent,
  },
  {path:'education-session-count-new',
    component:EducationSessionCountsNewComponent,
  },
  {
    path: 'education-presentation',
    component: EducationPresentationComponent
  },
  {
    path: 'education-presentation-list',
    component: EducationPresentationListComponent
  },
  {
    path: 'custom-unit-report',
    component: CustomUnitReportComponent
  },
  {
    path: 'impact-report-counseling/:id',
    component: ImpactReportCounselingComponent
  },
  {
    path: 'view-impact-report-counseling/:id',
    component: ViewImpactReportCounselingComponent
  },
  {
    path: 'impact-report-counseling-table',
    component: CounselingImpactReportTableComponent
  },
  {
    path: 'challenges',
    component: ChallengesComponent
  },
  {
    path: 'intervention',
    component: InterventionComponent
  },
  {
    path: 'count-report',
    component: CountTableComponent
  },
  {
    path: 'intervention-table',
    component: InterventionTableComponent
  },
  {
    path: 'progress-table',
    component: ProgressComponent
  },
  {
    path: 'follow-up',
    component: FollowUpComponent
  },

  {
    path: 'report-card-table',
    component: ReportCardTableComponent
  },
  {
    path: 'report-card',
    component: ReportCard
  },
  {
    path: 'follow-up-overview',
    component: FollowupSessionsOverviewComponent
  },
  {
    path: 'follow-up-overview2',
    component: CounsellingOverview2Component
  },
  {
    path: 'follow-up-overview',
    component: FollowupSessionsOverviewComponent
  },
  {
    path: 'report-card/:id',
    component: ReportCard,
    data: {viewMode: false}
  },
  {
    path: 'report-card-view/:id',
    component: ReportCard,
    data: {viewMode: true}
  },
  {
    path: 'report-card/:id',
    component: ReportCard
  },
  {
    path: 'counselling-count-report',
    component: CounsellingSessionCountReportComponent
  },{
    path: 'counselling-session-report',
    component: CounsellingSessionsCountComponent  //NEW
  },
  {
    path: 'education-count-report',
    component: EducationCountReportComponent
  },
  {
    path: 'education-highlight-report',
    component: EducationHightlightReportComponent
  },
  {
    path: 'attendance',
    component: AttendanceReportComponent
  },

  {
    path: 'average-occupancy',
    component: OccupancyComponent
  },
  {
    path: 'location-state-report',
    component: LocationStateReportComponent
  },
  {
    path: 'allergy-type-report',
    component: AllergyTypeReportComponent
  },
  {
    path: 'blood-group-report',
    component: BloodGroupReportComponent
  },
  {
    path: 'admission-log-history',
    component: AddmissionLogHistoryComponent
  },
  {
    path: 'gender-report',
    component: GenderCountReportComponent
  },

  {
    path: 'units',
    component: UnitReportComponent
  },
  {
    path: 'hospitals',
    component: HospitalReportComponent
  },
  {
    path: 'age-group',
    component: AgeGroupReportComponent
  },
  {
    path: 'hospital-count-report',
    component: HospitalCountReportComponent
  },
  {
    path: 'treatment-duration',
    component: TreatmentDurationComponent
  },
  {
    path: 'child-case-study',
    component: ChildCaseStudyComponent
  },
  {
    path: 'view-child-case-study/:id',
    component: ChildCaseStudyViewComponent,
    data: {viewMode: true}
  },
  {
    path: 'Add-child-case-study',
    component: AddChildCaseStudyComponent,
  },
  {
    path: 'Add-child-case-study/:id',
    component: AddChildCaseStudyComponent,
  },
  {
    path: 'discharge-reason-report',
    component: DischargeReasonReportComponent
  },
  {
    path:'counselling-presentation-list',
    component:CounsellingPresentationListComponent
  },
  {
    path: 'counselling-presentation',
    component: CounsellingPresentationComponent
  },
  {
    path: 'revised-child-report',
    component: RevisedChildReportComponent
  },
  {
    path: 'om-shanti-report',
    component: OmShantiReportComponent
  },
  {
    path: 'annual-impact-report',
    component: AnnualImpactReportComponent
  },
  {
    // Reopens a saved report (Edit on the report list).
    path: 'annual-impact-report/:id',
    component: AnnualImpactReportComponent
  },
  {
    path: 'annual-impact-report-table',
    component: AnnualImpactReportTableComponent
  },
  {
    path: 'average-stay-report',
    component: AverageStayReportComponent
  },
  {
    path: 'narrative-impact-report',
    component: NarrativeImpactReportComponent
  },
  {
    // Reopens a saved report (Edit on the report list).
    path: 'narrative-impact-report/:id',
    component: NarrativeImpactReportComponent
  },
  {
    path: 'narrative-impact-report-table',
    component: NarrativeImpactReportTableComponent
  }
]

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes),
    CommonModule

  ],
  exports: [RouterModule]
})
export class ReportsRoutingModule {


}
